








































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { imageUrl } from '@/shared/utils/images'

@Component
export default class MiniatureItem extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly alt!: string

  @Prop({
    required: true,
    type: String,
  })
  public readonly image!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly noActions!: boolean

  get showActions(): boolean {
    return this.noActions !== true
  }

  public imageUrl = imageUrl
}
